import { hotelConfig } from "./hotelConfig";

const hotelId = process.env.REACT_APP_HOTEL_KEY

export const hotelData = hotelConfig[hotelId];